import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Merges|Queue|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPToolsMergesQueue';
export type SPToolsMergesQueueLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleSectionCandidate`
	| `${LocNameStart}ButtonReviewMerge`
	| `${LocNameStart}LabelCreated`
	| `${LocNameStart}LabelWinner`
	| `${LocNameStart}LabelWinnerUpdator`
	| `${LocNameStart}LabelLoser`
	| `${LocNameStart}LabelLoserUpdator`
	| `${LocNameStart}LabelRequester`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelDetails`;

export const spToolsMergesQueueLocs: LocDefs<SPToolsMergesQueueLocNames> = {
	SPToolsMergesQueueTitleTab: {
		defaultValue: 'Merge Queue',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.Title.Tab',
		...sharedProperties,
	},
	SPToolsMergesQueueTitleSection: {
		defaultValue: 'Merge Queue',
		description: 'User Section Title',
		displayPath: `${pathStart}User Section Title`,
		displayType: 'Title',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.Title.MergeQueue',
		...sharedProperties,
	},
	SPToolsMergesQueueTitleSectionCandidate: {
		defaultValue: 'Candidate Requested Merges',
		description: 'Candidate Section Title',
		displayPath: `${pathStart}Candidate Section Title`,
		displayType: 'Title',
		legacyName:
			'MergeCandidates.CandidateSelfMerge/Tools.Merges.MergeQueue.Title.CandidateMergeQueue',
		...sharedProperties,
	},
	SPToolsMergesQueueButtonReviewMerge: {
		defaultValue: 'Review Merge',
		description: 'Review Merge button',
		displayPath: `${pathStart}Review Merge`,
		displayType: 'Button',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.Button.ReviewMerge',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelCreated: {
		defaultValue: 'Created',
		description: 'Column heading: Created.',
		displayPath: `${pathStart}Created`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.Created',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelWinner: {
		defaultValue: 'Winner',
		description: 'Column heading: Winner.',
		displayPath: `${pathStart}Winner`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.Winner',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelWinnerUpdator: {
		defaultValue: 'Winner Updator',
		description: 'Column heading: Winner Updator.',
		displayPath: `${pathStart}Winner Updator`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.WinnerUpdator',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelLoser: {
		defaultValue: 'Loser',
		description: 'Column heading: Loser.',
		displayPath: `${pathStart}Loser`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.Loser',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelLoserUpdator: {
		defaultValue: 'Loser Updator',
		description: 'Column heading: Loser Updator.',
		displayPath: `${pathStart}Loser Updator`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.LoserUpdator',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelRequester: {
		defaultValue: 'Requester',
		description: 'Column heading: Requester.',
		displayPath: `${pathStart}Requester`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelStatus: {
		defaultValue: 'Status',
		description: 'Column heading: Status.',
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.Status',
		...sharedProperties,
	},
	SPToolsMergesQueueLabelDetails: {
		defaultValue: 'Details',
		description: 'Column heading: Details.',
		displayPath: `${pathStart}Details`,
		displayType: 'Label',
		legacyName: 'MergeCandidates/Tools.Merges.MergeQueue.ColumnHeading.Details',
		...sharedProperties,
	},
};

export type SPToolsMergesQueueLocType = LocMap<SPToolsMergesQueueLocNames>;
